import script from "./lySettingPannel.vue?vue&type=script&setup=true&lang=js"
export * from "./lySettingPannel.vue?vue&type=script&setup=true&lang=js"

import "./lySettingPannel.vue?vue&type=style&index=0&id=181d7f17&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-181d7f17"]])

export default __exports__